import React from 'react';
import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import Steps from 'modules/Security/components/Steps';
import './style.scss';

interface BindAccountProps {
    type: 'bindPhone' | 'bindEmail';
}

const BindAccount: React.FC<BindAccountProps> = ({ type }) => {
    return (
        <Card form>
            <h2>{type === 'bindEmail' ? __('绑定邮箱') : __('绑定手机号')}</h2>
            <div className="bind-account-root">
                <Steps type={type} />
                <Outlet />
            </div>
        </Card>
    );
};

export default BindAccount;
